// extracted by mini-css-extract-plugin
module.exports = {"field":"SpecSectionItem_field__6JA_m","print":"SpecSectionItem_print___n4S4","label":"SpecSectionItem_label__NZpuM","value":"SpecSectionItem_value__8PWyr"};